var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCoaches({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8232 23.3145V20.8145C18.8232 19.4884 18.2965 18.2166 17.3588 17.2789C16.4211 16.3412 15.1493 15.8145 13.8232 15.8145H6.32324C4.99716 15.8145 3.72539 16.3412 2.78771 17.2789C1.85003 18.2166 1.32324 19.4884 1.32324 20.8145V23.3145M18.8232 0.974453C19.8954 1.25242 20.845 1.87853 21.5228 2.75453C22.2007 3.63053 22.5685 4.70681 22.5685 5.81445C22.5685 6.92209 22.2007 7.99838 21.5228 8.87438C20.845 9.75037 19.8954 10.3765 18.8232 10.6545M26.3232 23.3145V20.8145C26.3224 19.7066 25.9537 18.6304 25.2749 17.7548C24.5962 16.8793 23.6459 16.2539 22.5732 15.977M15.0732 5.81445C15.0732 8.57588 12.8347 10.8145 10.0732 10.8145C7.31182 10.8145 5.07324 8.57588 5.07324 5.81445C5.07324 3.05303 7.31182 0.814453 10.0732 0.814453C12.8347 0.814453 15.0732 3.05303 15.0732 5.81445Z",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCoaches);
export default __webpack_public_path__ + "static/media/activeCoaches.e9b24749bdb1633dfb2ed0be51ecb60b.svg";
export { ForwardRef as ReactComponent };